'use client';

import { memo } from 'react';

export interface Menu {
  name: string;
  link?: { pathname: string };
  auth?: boolean;
  action?: 'logout';
}

interface MenuItemProps {
  menu: Menu;
  onClick: (menu: Menu) => void;
}

// li 자체는 클릭 불가(키보드/SR 접근 불가) → 내부 button 으로 렌더해 Tab 포커스 + Enter/Space 활성화.
const MenuItem = memo(({ menu, onClick }: MenuItemProps) => (
  <li className="w-full">
    <button
      type="button"
      onClick={() => onClick(menu)}
      className="flex w-full cursor-pointer flex-col gap-4 text-left"
    >
      <span className="w-full text-base font-medium leading-5 text-g-00">{menu.name}</span>
      <div className="h-0 w-full border-b-[0.5px] border-seoleimrun-primary-10" />
    </button>
  </li>
));

MenuItem.displayName = 'MenuItem';

export default MenuItem;
